// @ts-nocheck
import { colors } from '@lmc/common/constants'
import { getNominative } from 'common/utils'
import { Gallery, GalleryItem } from 'components/Gallery'
import dayjs from 'dayjs'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { Icon } from '../Icon'
import { Popup, SuInvolved, VideoEl, VideoThumbnail } from '../LogSharedStyles'
import VideoPreview from '../VideoPreview'
import { formatDate, getColor, getIcon, getWitnessName } from './utils'

const LoggedBy = ({ carer }) => {
  if (!carer) return null
  return (
    <SmallText style={{ color: colors.darkgrey }}>
      {carer.name.first} {carer.name.last}
    </SmallText>
  )
}

const LoggedAt = ({ data }) => {
  if (!data) return null
  const originalTimeLog = dayjs(data.originalTimeLog).subtract(15, 'seconds')
  const timeLogged = dayjs(data.timeLogged)
  const dayLogSavedTimedAt = dayjs(data.originalTimeLog).format('D')
  const dayLogChangedTimeAt = dayjs(data.timeLogged).format('D')
  const isSameDay = dayLogChangedTimeAt === dayLogSavedTimedAt

  let logDetailsText = ''
  if (data.originalTimeLog && timeLogged.isBefore(originalTimeLog)) {
    if (isSameDay) {
      logDetailsText = `, logged at: ${dayjs(data.originalTimeLog).format(
        'HH:mm'
      )}`
    } else {
      logDetailsText = `, logged at: ${dayjs(data.originalTimeLog).format(
        'DD/MM/YY HH:mm'
      )}`
    }
  }
  if (data.witnessedBy) {
    logDetailsText += `, witnessed by ${getWitnessName(data.witnessedBy)}`
  }

  if (!logDetailsText) return null
  return <SmallText>{logDetailsText}</SmallText>
}

export default function LogSummary({
  data,
  linkEnabled = true,
  logStyle = undefined,
  onSelect,
  isLogRemoved,
  testId
}) {
  const color = getColor(data)
  const icon = getIcon(data)
  const showEditedBy = data.editedBy && data.editedBy.id && data.editedAt
  const pictures = [data.picture1, data.picture2, data.picture3].filter(
    (p) => p
  )
  const { videoThumbnail, videoFile } = data
  const onClick = () => onSelect(`logs/${data.id}`)
  const opacity = isLogRemoved && 0.2
  const [isVideoOpen, setIsVideoOpen] = useState(false)
  const [selectedImage, setSelectedImage] = useState('')
  const toggleVideoPopup = () => {
    setIsVideoOpen(!isVideoOpen)
  }

  const [isImageOpen, setIsImageOpen] = useState(false)
  const toggleImagePopup = () => {
    setIsImageOpen(!isImageOpen)
  }
  const preferredPeopleNominative = useSelector(
    (state) => state.global.home.preferredPeopleNominative
  )
  const nominative = getNominative(preferredPeopleNominative, 'Service user')

  return (
    <LogContainer
      $clickable={!logStyle && linkEnabled}
      $hasLogStyle={!!logStyle}
      onClick={linkEnabled ? onClick : null}
      style={logStyle}
      data-testid={testId ? `${testId}-log-summary` : undefined}
    >
      <IconContainer
        style={{ backgroundColor: isLogRemoved ? colors.grey : color }}
        data-testid={testId ? `${testId}-log-icon` : undefined}
      >
        <Icon_ alt="" src={icon} />
      </IconContainer>
      <div>
        <LoggedContainer>
          <LoggedBy carer={data?.loggedBy} />
          <LoggedAt data={data} />
        </LoggedContainer>
        <Title
          style={{ color: isLogRemoved ? colors.darkgrey : null }}
          data-testid={testId ? `${testId}-log-title` : undefined}
        >
          {isLogRemoved ? 'Log Removed' : data.title}
        </Title>
        <Description
          data-testid={testId ? `${testId}-log-description` : undefined}
        >
          {!isLogRemoved ? data.description : null}
        </Description>
        {showEditedBy && (
          <SmallText
            style={{
              color: colors.darkgrey,
              marginTop: 5
            }}
          >
            {isLogRemoved ? 'Removed by' : 'Edited by'}{' '}
            {data.editedBy.name.first} {data.editedBy.name.last} on{' '}
            {formatDate(data.editedAt)}
          </SmallText>
        )}
        {data.doneBySu && (
          <SuInvolved>{nominative} was involved in writing this log</SuInvolved>
        )}
        <GalleryWrapper>
          <Gallery>
            {pictures.map((url) => (
              <GalleryItem
                key={url}
                src={url}
                alt="Log photo"
                className={undefined}
                style={{
                  opacity,
                  height: 100,
                  borderRadius: 10,
                  background: colors.background,
                  cursor: 'pointer'
                }}
                width={749}
                height={1000}
              />
            ))}
          </Gallery>
          {videoFile && (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <VideoThumbnail
              onClick={(e) => {
                e.stopPropagation()
                toggleVideoPopup()
              }}
              data-testid={testId ? `${testId}-video-thumbnail` : undefined}
            >
              <Icon
                name="play"
                fill={colors.white}
                size={32}
                style={{
                  position: 'absolute',
                  marginTop: 30,
                  marginLeft: 20
                }}
              />
              <VideoPreview
                videoFile={videoFile}
                videoThumbnail={videoThumbnail}
                testId={testId ? `${testId}-video-thumbnail-image` : undefined}
                style={{
                  height: 100,
                  width: 75,
                  borderRadius: 10,
                  background: colors.background,
                  cursor: 'pointer'
                }}
              />
            </VideoThumbnail>
          )}
          {isImageOpen && (
            <Popup
              content={
                <PicturePreview
                  alt=""
                  src={selectedImage}
                  data-testid={testId ? `${testId}-image-popup` : undefined}
                />
              }
              handleClose={(e) => {
                toggleImagePopup()
                e.stopPropagation()
              }}
            />
          )}
        </GalleryWrapper>
        {isVideoOpen && (
          <Popup
            content={
              <VideoEl
                controls
                data-testid={testId ? `${testId}-video-popup` : undefined}
              >
                <source src={videoFile} type="video/mp4" />
                <track
                  src="captions_en.vtt"
                  kind="captions"
                  label="english_captions"
                />
              </VideoEl>
            }
            handleClose={(e) => {
              toggleVideoPopup()
              e.stopPropagation()
            }}
          />
        )}
      </div>
    </LogContainer>
  )
}

const Description = styled.span`
  color: ${colors.black};
  display: block;
  margin-top: 2px;
`

const GalleryWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
`

const Icon_ = styled.img`
  width: 20px;
`

const IconContainer = styled.div`
  align-items: center;
  border-radius: 46px;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  height: 46px;
  margin-right: 12px;
  width: 46px;
  align-self: flex-start;
`

const LogContainer = styled.div<{
  $clickable?: boolean
  $hasLogStyle?: boolean
}>`
  ${({ $hasLogStyle }) =>
    !$hasLogStyle &&
    `
    align-items: center;
    display: flex;
    line-height: 1.4;
    width: 55%;
  `}
  ${({ $clickable }) => $clickable && `cursor: pointer;`}
`

const LoggedContainer = styled.div`
  display: flex;
`

const PicturePreview = styled.img`
  max-height: 60vh;
  align-self: center;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  background: ${colors.background};
  display: flex;
  margin-left: auto;
  margin-right: auto;
`

const SmallText = styled.span`
  color: ${colors.darkgrey};
  display: block;
  font-size: 12px;
`

const Title = styled.span`
  color: ${colors.black};
  display: block;
  font-weight: 600;
`
